import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent/index';
import CommentCard from '../../components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionStepInfo/TaskCompletionStepComments/CommentCard';
import expandor from '../../assets/images/expandor.svg';
import contractor from '../../assets/images/contractor.svg';

import './CommentList.scss';

class CommentList extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
    };
  }

  buildCommentList(comments) {
    const commentCards = comments.map(comment => {
      return <CommentCard comment={comment} key={'Comment_list_' + (comment.id ? comment.id : Math.random())} />;
    });
    return commentCards;
  }

  handleCommentsExpand() {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { comments } = this.props;
    const commentList = this.buildCommentList(comments);

    return (
      <div className="comment-list-container">
        <div className="comment-list__divider" />
        <div className="comment-list comment-list__main">
          <div className="comment-list__header">
            <div className="comment-list__label">COMMENTS</div>
            <img
              src={this.state.expanded ? contractor : expandor}
              alt="expand"
              onClick={this.handleCommentsExpand}
              className="comment-list__expander"
            />
          </div>

          <div className={'comment-list__comments ' + (this.state.expanded ? '' : 'closed')}>
            {commentList && commentList.length ? (
              commentList
            ) : (
              <div className="empty-comments-label">No Comments found.</div>
            )}
          </div>
        </div>
        <div className="comment-list__divider" />
      </div>
    );
  }
}

export default CommentList;



// WEBPACK FOOTER //
// ./src/components/CommentList/index.js